import { render, staticRenderFns } from "./CustomerLoanDetails.vue?vue&type=template&id=6b7f1b28&scoped=true"
import script from "./CustomerLoanDetails.vue?vue&type=script&lang=js"
export * from "./CustomerLoanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f1b28",
  null
  
)

export default component.exports